import { createContext } from "react";
import { ItemPricing } from "../../types";
import { OrderDetail } from "../../types";

type OrderContextType = {
  // Order
  orderDetail?: OrderDetail;
  reducedOrderItems: ItemPricing[];
  isOrderLoaded: boolean;
};

export const OrderContext = createContext<OrderContextType>({
  orderDetail: undefined,
  reducedOrderItems: [],
  isOrderLoaded: false,
});
